<template>
  <div id="gastosAMEX">
    <v-layout wrap>
      <v-flex xs3>
        <v-container>
          <v-menu ref="menuDateStart" :close-on-content-click="false" v-model="menuDateStart" :nudge-right="40"
            :return-value.sync="menuDateStart" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaInicio" label="Fecha Inicio" readonly></v-text-field>
            <v-date-picker v-model="fechaInicio" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateStart = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateStart.save(fechaInicio)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container>
      </v-flex>
      <v-flex xs3>
        <v-container>
          <v-menu ref="menuDateEnd" :close-on-content-click="false" v-model="menuDateEnd" :nudge-right="40"
            :return-value.sync="menuDateEnd" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaFin" label="Fecha Fin" readonly></v-text-field>
            <v-date-picker v-model="fechaFin" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateEnd = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateEnd.save(fechaFin)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container>
      </v-flex>
    </v-layout>
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Solicitudes de Gastos AMEX</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn v-if="roles.indexOf('solicitud_amex') >= 0" slot="activator" :loading="loading" icon @click="newSol()">
            <v-icon>note_add</v-icon>
          </v-btn>
          <span>Nueva Solicitud AMEX (Consolidada)</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="solicitudes" :loading="loading" :search="search" class="elevation-1"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" :items-per-page="10">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="{ item }">
          <tr>
            <td class="text-xs-center">{{ item.idsolicitud_amex }}</td>
            <td class="text-xs-center">{{ item.empresa }}</td>
            <td class="text-xs-center">{{ formatDate(item.fecha_corte) }}
            </td>
            <td class="text-xs-center">{{ formatDate(item.fecha_pago) }}
            </td>
            <td class="text-xs-center">{{
              formatCurrency(item.saldo_a_pagar) }}</td>
            <td class="text-xs-center">{{
              formatCurrency(item.importe_comprobado) }}</td>
            <td class="text-xs-center">{{ item.estatus }}</td>
            <td class="text-xs-center">{{ item.estatus_comprobacion }}
            </td>
            <td class="text-xs-center">{{ formatDate(item.fecha_creacion)
            }}</td>
            <td class="text-xs-center">{{ item.usuario_creacion }}</td>
            <td class="text-xs-center">{{ item.estados_cuenta_activos || 0
            }}</td>
            <td class="text-xs-center">{{
              item.solicitudes_comprobacion_aprobadas || 0
              }}</td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <v-btn slot="activator" small icon @click="showResumenRapido(item)">
                  <v-icon>visibility</v-icon>
                </v-btn>
                <span>Ver resumen rápido</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn slot="activator" small icon @click="showDetailRep(item.idsolicitud_amex)">
                  <v-icon>description</v-icon>
                </v-btn>
                <span>Ver Detalles</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn slot="activator" small icon
                  @click="$router.push({ name: 'ComprobacionesAMEX', params: { idsolicitud_amex: item.idsolicitud_amex } })">
                  <v-icon>format_list_bulleted</v-icon>
                </v-btn>
                <span>Comprobaciones</span>
              </v-tooltip>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          <div class="text-xs-center">No hay solicitudes registradas.</div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogNewReq" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="confirmCloseReq = true">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Nueva Solicitud AMEX (Consolidada)</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="checkQuestionReq()">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-select v-model="solicitud.centro" :error-messages="centroErrors" :items="catalogos.centros"
                    :item-text="centroText" item-value="idcat_centro_costo" label="Centro de costos"
                    @input="$v.solicitud.centro.$touch()" @blur="$v.solicitud.centro.$touch()" />

                  <v-select v-model="solicitud.direccion" :error-messages="direccionErrors"
                    :items="catalogos.direcciones" :item-text="centroText" item-value="idcat_direccion"
                    label="Direccion" @input="$v.solicitud.direccion.$touch()"
                    @blur="$v.solicitud.direccion.$touch()" />

                  <v-select v-model="solicitud.empresa" :error-messages="empresaErrors" :items="catalogos.empresas"
                    :item-text="centroText" item-value="idcat_empresa" label="Empresa"
                    @input="$v.solicitud.empresa.$touch()" @blur="$v.solicitud.empresa.$touch()" />
                  <v-text-field label="Total a pagar a proveedor" :value="totalSaldoProveedorFormatted" readonly />
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-select v-model="solicitud.departamento" :error-messages="departamentoErrors"
                    :items="catalogos.departamentos" :item-text="centroText" item-value="idcat_departamento"
                    label="Departamento" @input="$v.solicitud.departamento.$touch()"
                    @blur="$v.solicitud.departamento.$touch()" />

                  <v-select v-model="solicitud.puesto" :error-messages="puestoErrors" :items="catalogos.puestos"
                    :item-text="centroText" item-value="idcat_puesto" label="Puesto"
                    @input="$v.solicitud.puesto.$touch()" @blur="$v.solicitud.puesto.$touch()" />

                  <h3 class="grey--text text-xs-center">CARGAR ESTADOS DE CUENTA</h3><br />
                  <v-layout v-if="dialogNewReq" wrap justify-center>
                    <v-flex xs12 sm12 md6>
                      <v-btn block :loading="loading" round :color="color.pagare" @click="$refs.edc.click()">
                        CARGAR
                        <v-icon right dark>attach_file</v-icon>
                      </v-btn>
                      <input v-show="false" ref="edc" type="file" @change="readFile('edc')">
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>

            </v-layout>
          </v-container>
          <v-toolbar dense dark color="blue-grey">
            <v-toolbar-title>Estados de Cuenta</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table :headers="headersEC" :items="estados_cuenta" :loading="loading" :search="search"
            class="elevation-1" rows-per-page-text="Registros por página" :pagination.sync="pagination"
            :items-per-page="10">
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td class="text-xs-center">{{ item.tarjetahabiente }}
                </td>
                <td class="text-xs-center">{{
                  item.proveedor }}
                </td>
                <td class="text-xs-center">{{ item.descripcion }}</td>
                <td class="text-xs-center">{{ formatDateTable(item.fecha_corte)
                }}
                </td>
                <td class="text-xs-center">{{ formatDateTable(item.fecha_pago)
                }}
                </td>
                <td class="text-xs-center">{{ formatCurrency(item.saldo_a_pagar) }}</td>
                <td class="text-xs-center">
                  <v-btn icon color="red" dark @click="confirmDeleteEstadoCuenta(item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <div class="text-xs-center">No hay estados de cuenta.</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="alert" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="questionReq" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea guardar la nueva solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionReq = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="saveSol()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmCloseReq" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">¿Está seguro que desea salir?</v-card-title>
        <v-card-text>
          Va a cerrar esta ventana. Perderá los cambios capturados.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="confirmClose()">Salir</v-btn>
          <v-btn color="green" dark @click="confirmCloseReq = false">Mantenerse en solicitud</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteEC" max-width="400">
      <v-card>
        <v-card-title class="headline">¿Eliminar estado de cuenta?</v-card-title>
        <v-card-text>Esta acción no se puede deshacer.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialogDeleteEC = false">Cancelar</v-btn>
          <v-btn color="green" dark @click="deleteEstadoCuentaConfirmado">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogResumen" max-width="600px">
      <v-card>
        <v-card-title class="headline justify-center">
          Resumen de Tarjetahabientes
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="[
            { text: 'Tarjetahabiente', value: 'tarjetahabiente', sortable: false },
            { text: 'Saldo a pagar', value: 'saldo_a_pagar', sortable: false }
          ]" :items="resumenTarjetahabientes" class="elevation-1" hide-default-footer>
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>{{ item.tarjetahabiente }}
                </td>
                <td class="text-xs-center">{{
                  formatCurrency(item.saldo_a_pagar) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogResumen = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetalleAmex" fullscreen hide-overlay :persistent="true"
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="closeDetailRep()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-center">Detalle de Solicitud AMEX: {{ detalleAMEX.idsolicitud_amex
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- Columna: Datos Generales -->
              <v-flex xs12 sm12 md6>
                <h3 class="grey--text">Datos Generales</h3><br />
                <v-text-field v-model="detalleAMEX.empresa.nombre" label="Empresa" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.descripcion" label="Concepto" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.centro_costo.nombre" label="Centro de costos" box
                  disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.direccion.nombre" label="UEN / Plaza" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.departamento.nombre" label="Departamento" box
                  disabled></v-text-field>

                <br />
                <h3 class="grey--text">Información adicional</h3><br />
                <v-text-field :value="formatDateTimeCDMX(detalleAMEX.fecha_creacion)" label="Fecha de solicitud" box
                  disabled></v-text-field>
                <v-text-field :value="detalleAMEX.solicitante" label="Solicitante" box disabled></v-text-field>

              </v-flex>

              <!-- Columna: Datos de Pago -->
              <v-flex xs12 sm12 md6>
                <h3 class="grey--text">Datos de Pago</h3><br />
                <v-text-field v-model="detalleAMEX.proveedor" label="Proveedor" box disabled></v-text-field>
                <v-text-field v-model="detalleAMEX.descripcion" label="Descripción" box disabled></v-text-field>
                <v-text-field :value="formatDateShort(detalleAMEX.fecha_pago)" label="Fecha de Pago" box disabled />
                <v-text-field :value="formatCurrency(detalleAMEX.saldo_a_pagar)" label="Saldo a Pagar" box disabled />
              </v-flex>
            </v-layout>
            <h3 class="grey--text">Estados de Cuenta Asociados</h3><br />
            <v-data-table :headers="headersDetalleEdc" :items="detalleAMEX.estados_cuenta" class="elevation-1"
              hide-default-footer>
              <template slot="items" slot-scope="{ item }">
                <tr>
                  <td>{{ formatDateShort(item.fecha_corte) }}</td>
                  <td>{{ formatDateShort(item.fecha_pago) }}</td>
                  <td>{{ formatPeriodo(item.periodo) }}</td>
                  <td>{{ item.tarjetahabiente }}</td>
                  <td>{{ item.asistente }}</td>
                  <td>{{ formatCurrency(item.saldo_a_pagar) }}</td>
                </tr>
              </template>
            </v-data-table>

          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import services from "@/config/services";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";

export default {
  name: "SolicitudesAmex",
  mixins: [validationMixin],
  validations: {
    solicitud: {
      centro: {
        required: requiredIf(function () {
          return true;
        })
      },
      direccion: {
        required: requiredIf(function () {
          return true;
        })
      },
      empresa: {
        required: requiredIf(function () {
          return true;
        })
      },
      departamento: {
        required: requiredIf(function () {
          return true;
        })
      },
      puesto: {
        required: requiredIf(function () {
          return true;
        })
      }
    }
  },
  data() {
    return {
      color: {
        pagare: "",
        responsiva: ""
      },
      dialogDetalleAmex: false,
      detalleAMEX: {
        empresa: {},
        centro_costo: {},
        direccion: {},
        departamento: {}

      },
      headersDetalleEdc: [
        { text: 'Fecha Corte', value: 'fecha_corte', sortable: false },
        { text: 'Fecha Pago', value: 'fecha_pago', sortable: false },
        { text: 'Periodo', value: 'periodo', sortable: false },
        { text: 'Tarjetahabiente', value: 'tarjetahabiente', sortable: false },
        { text: 'Asistente', value: 'asistente', sortable: false },
        { text: 'Saldo a Pagar', value: 'saldo_a_pagar', sortable: false }
      ],

      headersEdc: [
        { text: 'Fecha Corte', value: 'fecha_corte' },
        { text: 'Fecha Pago', value: 'fecha_pago' },
        { text: 'Periodo', value: 'periodo' },
        { text: 'Tarjetahabiente', value: 'tarjetahabiente' },
        { text: 'Asistente', value: 'asistente' },
        { text: 'Saldo a Pagar', value: 'saldo_a_pagar' }
      ],

      detalle: null,
      dialogDeleteEC: false,
      estadoCuentaSeleccionado: null,
      questionReq: false,
      confirmCloseReq: false,
      msgError: "",
      msgSuccess: "",
      success: false,
      dialogNewReq: false,
      loading: false,
      alert: false,
      search: "",
      solicitudes: [],
      estados_cuenta: [],
      menuDateStart: false,
      menuDateEnd: false,
      fechaInicio: "",
      fechaFin: "",
      dialogResumen: false,
      resumenTarjetahabientes: [],
      pagination: {
        rowsPerPage: 7
      },
      headers: [
        { text: "ID", value: "idsolicitud_amex", sortable: false },
        { text: "Empresa", value: "empresa", sortable: false },
        { text: "Fecha Corte", value: "fecha_corte", sortable: false },
        { text: "Fecha Pago", value: "fecha_pago", sortable: false },
        { text: "Importe solicitado", value: "saldo_a_pagar", sortable: false },
        {
          text: "Importe comprobado",
          value: "importe_comprobado",
          sortable: false
        },
        { text: "Estatus", value: "estatus", sortable: false },
        {
          text: "Estatus comprobación",
          value: "estatus_comprobacion",
          sortable: false
        },
        { text: "Fecha de registro", value: "fecha_creacion", sortable: false },
        {
          text: "Usuario creación",
          value: "usuario_creacion",
          sortable: false
        },
        {
          text: "Estados de cuenta",
          value: "estados_cuenta_activos",
          sortable: false
        },
        {
          text: "Comprobantes aprobados",
          value: "solicitudes_comprobacion_aprobadas",
          sortable: false
        },
        {
          text: "Acciones",
          value: "acciones",
          sortable: false,
          class: "text-xs-center"
        }
      ],
      headersEC: [
        {
          text: "Tarjetahabiente",
          value: "tarjetahabiente",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Proveedor",
          value: "proveedor",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Descripción",
          value: "descripcion",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Fecha Corte",
          value: "fecha_corte",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Fecha Pago",
          value: "fecha_pago",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Saldo a pagar",
          value: "saldo_a_pagar",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Acciones",
          value: "acciones",
          sortable: false,
          class: "text-xs-center"
        }
      ],
      solicitud: {
        estados_cuenta: []
      },
      catalogos: {
        centros: [],
        direcciones: [],
        empresas: [],
        departamentos: [],
        puestos: []
      },
      roles: []
    };
  },
  computed: {
    totalSaldoProveedor() {
      return this.estados_cuenta.reduce((sum, ec) => {
        const monto = parseFloat(ec.saldo_a_pagar || 0);
        return sum + (isNaN(monto) ? 0 : monto);
      }, 0);
    },
    totalSaldoProveedorFormatted() {
      return this.formatCurrency(this.totalSaldoProveedor);
    },
    centroErrors() {
      const errors = [];
      if (!this.$v.solicitud.centro.$dirty) return errors;
      !this.$v.solicitud.centro.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    direccionErrors() {
      const errors = [];
      if (!this.$v.solicitud.direccion.$dirty) return errors;
      !this.$v.solicitud.direccion.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    empresaErrors() {
      const errors = [];
      if (!this.$v.solicitud.empresa.$dirty) return errors;
      !this.$v.solicitud.empresa.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    departamentoErrors() {
      const errors = [];
      if (!this.$v.solicitud.departamento.$dirty) return errors;
      !this.$v.solicitud.departamento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    puestoErrors() {
      const errors = [];
      if (!this.$v.solicitud.puesto.$dirty) return errors;
      !this.$v.solicitud.puesto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    }
  },
  mounted() {
    this.setDates();
    this.fetchSolicitudes();
    this.ws("get", "check").then(res => {
      if (res.ok) {
        this.roles = res.data.roles;
      }
    });
  },
  methods: {
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    formatDateTimeCDMX(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    formatPeriodo(periodo) {
      if (!periodo || periodo.length !== 6) return "";
      const year = periodo.slice(0, 4);
      const month = periodo.slice(4, 6);
      return `${year}-${month}`;
    },
    closeDetailRep() {
      this.resetDetalle()
      this.dialogDetalleAmex = false
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const options = { day: '2-digit', month: 'short', year: 'numeric' };
      const parts = new Date(date).toLocaleDateString('es-MX', options).split(' ');

      const dia = parts[0];
      const mes = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
      const anio = parts[2];

      return `${dia}-${mes}-${anio}`;
    },
    showResumenRapido(item) {
      if (!item.estados_cuenta || item.estados_cuenta.length === 0) {
        this.resumenTarjetahabientes = [];
        return;
      }

      this.resumenTarjetahabientes = item.estados_cuenta.map(ec => ({
        tarjetahabiente: ec.tarjetahabiente,
        saldo_a_pagar: parseFloat(ec.saldo_a_pagar || 0)
      }));
      this.dialogResumen = true;
    },
    resetDetalle() {
      this.detalleAMEX = {
        empresa: {},
        centro_costo: {},
        direccion: {},
        departamento: {}
      }
    },
    reset() {
      this.solicitud = {
        centro: null,
        direccion: null,
        empresa: null,
        departamento: null,
        puesto: null,
        estados_cuenta: []
      };
      this.estados_cuenta = [];
      this.$v.$reset(); // Resetea validaciones
    },
    centroText(item) {
      return `${item.idexterno} - ${item.descripcion}`;
    },
    async showDetailRep(id) {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.amexSolicitudesDetalle.replace(
          ":idsolicitud_amex",
          id
        );
        const { data } = await axios.get(url, { headers });
        this.detalleAMEX = data
        this.detalleAMEX.solicitante = data.usuario_creacion.nombre + ` (${data.usuario_creacion.puesto})`
        this.detalleAMEX.proveedor = data.estados_cuenta[0].proveedor
        this.dialogDetalleAmex = true
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {

        this.loading = false;
      }
    },
    setDates() {
      const hoy = new Date();
      const tresMesesAntes = new Date(hoy.setMonth(hoy.getMonth() - 3));
      this.fechaInicio = tresMesesAntes.toISOString().slice(0, 10);
      this.fechaFin = new Date().toISOString().slice(0, 10);
    },
    async fetchSolicitudes() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };

        let detalleUsuario = await axios.get(services.routes.detalleUsuario, {
          headers
        });

        this.detalle = {
          departamento: detalleUsuario.data.data.detalle.departamento,
          direccion: detalleUsuario.data.data.detalle.direccion,
          empresa: detalleUsuario.data.data.detalle.empresa
        };

        const { data } = await axios.post(
          services.routes.amexSolicitudesList,
          {
            fecha_inicio: this.fechaInicio,
            fecha_fin: this.fechaFin
          },
          { headers }
        );
        this.solicitudes = data;
      } catch (err) {
        console.error("Error al cargar solicitudes:", err);
      } finally {
        this.loading = false;
      }
    },
    refresh() {
      this.fetchSolicitudes();
    },
    formatDateTable(date) {
      if (!date) return "";
      const options = {
        timeZone: "America/Mexico_City",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      };
      const formatter = new Intl.DateTimeFormat("es-MX", options);
      const formatted = formatter.format(new Date(date));
      const [dia, mes, anio, hora] = formatted.replace(",", "").split(" ");
      const mesUpper = mes.toUpperCase();
      return `${dia}-${mesUpper}-${anio} ${hora}`;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = n => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    formatCurrency(amount) {
      if (isNaN(amount)) return "$0.00";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },
    async newSol() {
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };

        let centros = await axios.post(
          services.routes.obtenerCatalogo,
          { tableName: "cat_centros_costos" },
          { headers }
        );
        this.catalogos.centros = centros.data.data.datos;
        let direcciones = await axios.post(
          services.routes.obtenerCatalogo,
          { tableName: "cat_direcciones" },
          { headers }
        );
        this.catalogos.direcciones = direcciones.data.data.datos;
        let empresas = await axios.post(
          services.routes.obtenerCatalogo,
          { tableName: "cat_empresas" },
          { headers }
        );
        this.catalogos.empresas = empresas.data.data.datos;
        this.catalogos.empresas = this.catalogos.empresas.filter(e => e.idcat_estatus == 1);
        let departamentos = await axios.post(
          services.routes.obtenerCatalogo,
          { tableName: "cat_departamentos" },
          { headers }
        );
        this.catalogos.departamentos = departamentos.data.data.datos;
        let puestos = await axios.post(
          services.routes.obtenerCatalogo,
          { tableName: "cat_puestos" },
          { headers }
        );
        this.catalogos.puestos = puestos.data.data.datos;

        const empresa = this.catalogos.empresas.find(
          e => e.descripcion === this.detalle.empresa
        );
        if (empresa) {
          this.solicitud.empresa = empresa.idcat_empresa;
        }

        const dirreccion = this.catalogos.direcciones.find(
          e => e.descripcion === this.detalle.direccion
        );
        if (dirreccion) {
          this.solicitud.direccion = dirreccion.idcat_direccion;
        }

        const departamento = this.catalogos.departamentos.find(
          e => e.descripcion === this.detalle.departamento
        );
        if (departamento) {
          this.solicitud.departamento = departamento.idcat_departamento;
        }
        this.dialogNewReq = true;
      } catch (err) {
        console.error("Error al catalogos:", err);
      } finally {
        this.loading = false;
      }
    },
    checkQuestionReq() {
      this.$v.$touch();
      this.questionReq = false;
      if (this.$v.$invalid) return;
      if (this.estados_cuenta.length == 0) {
        this.alert = true;
        this.msgError = "Debe cargar al menos 1 estado de cuenta.";
        return;
      }
      this.questionReq = true;
    },
    async saveSol() {
      this.false = true;
      this.questionReq = false;
      this.loading = true;
      try {
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        let data = {
          idcat_centro_costo: this.solicitud.centro,
          idcat_empresa: this.solicitud.empresa,
          idcat_direccion: this.solicitud.direccion,
          idcat_departamento: this.solicitud.departamento,
          proveedor: this.estados_cuenta[0].proveedor,
          descripcion: this.estados_cuenta[0].descripcion,
          fecha_corte: this.estados_cuenta[0].fecha_corte,
          fecha_pago: this.estados_cuenta[0].fecha_pago,
          estados_cuenta: this.solicitud.estados_cuenta
        };
        data.saldo_a_pagar = this.estados_cuenta.reduce(
          (sum, ec) => sum + parseFloat(ec.saldo_a_pagar || 0),
          0
        );

        let res = await axios.post(services.routes.amexProcesarCreate, data, {
          headers
        });
        this.reset();
        this.close();
        this.refresh();
        this.success = true;
        this.msgSuccess = "Solicitud guardada correctamente";
      } catch (err) {
        this.loading = false;
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
      } finally {
        this.loading = false;
      }
    },
    confirmClose() {
      this.reset();
      this.dialogNewReq = false;
      this.confirmCloseReq = false;
    },
    confirmDeleteEstadoCuenta(item) {
      this.estadoCuentaSeleccionado = item;
      this.dialogDeleteEC = true;
    },

    async deleteEstadoCuentaConfirmado() {
      try {
        this.loading = true;
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        let data = {
          idestado_cuenta_amex: this.estadoCuentaSeleccionado
            .idestado_cuenta_amex
        };
        let res = await axios.post(services.routes.eliminarEdcAMEX, data, {
          headers
        });
        const index = this.estados_cuenta.findIndex(
          ec =>
            ec.idestado_cuenta_amex ===
            this.estadoCuentaSeleccionado.idestado_cuenta_amex
        );
        if (index !== -1) {
          this.estados_cuenta.splice(index, 1);
          const idxSolicitud = this.solicitud.estados_cuenta.indexOf(
            this.estadoCuentaSeleccionado.idestado_cuenta_amex
          );
          if (idxSolicitud !== -1) {
            this.solicitud.estados_cuenta.splice(idxSolicitud, 1);
          }
        }
        this.dialogDeleteEC = false;
        this.estadoCuentaSeleccionado = null;
        this.success = true;
        this.msgSuccess = "Estado de cuenta borrado correctamente";
      } catch (err) {
        this.loading = false;
        this.alert = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.$v.$reset();
      this.confirmCloseReq = false;
      this.dialogNewReq = false;
    },
    readFile(doc) {
      return new Promise(() => {
        this.loading = true;
        this.alert = false;
        let fr = new FileReader();
        let file = this.$refs[doc].files;
        let size = file[0].size;
        if (size <= 10000000) {
          fr.onload = () => {
            const formData = new FormData();
            formData.append("pdf", file[0]);
            const jwt = this.$session.get("jwt");
            axios
              .post(services.routes.amexProcesarPdf, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${jwt}`
                }
              })
              .then(res => {
                let data = res.data;
                this.$refs[doc].value = null;
                data.descripcion = `Comprobación de tarjeta AMEX - ${data.tarjetahabiente
                  }`;
                this.estados_cuenta.push(data);
                this.solicitud.estados_cuenta.push(data.idestado_cuenta_amex);
                this.loading = false;
                this.success = true;
                this.msgSuccess = "Estado de cuenta cargado";
              })
              .catch(err => {
                this.loading = false;
                this.alert = true;
                if (err && err.response && err.response.data) {
                  this.msgError =
                    err.response.data.message || "Error del servidor";
                } else {
                  this.msgError = err.message || "Error desconocido";
                }
                this.$refs[doc].value = null;
              });
          };
          fr.onerror = () => {
            this.color[doc] = "";
            this.alert = true;
            this.msgError = "El archivo no fue leído correctamente";
            this.loading = false;
          };
          fr.readAsDataURL(file[0]);
        } else {
          this.alert = true;
          this.msgError = "El archivo ha excedido el límite permitido (10 MB)";
          this.loading = false;
        }
      });
    }
  }
};
</script>